import { api } from "@services/api"

import { AuthResponse, LoginFormValues, User, UserOrganizationAccess } from "../types"

export const authService = {
  login: async (credentials: LoginFormValues, recaptchaToken: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>("/auth/login", {
      ...credentials,
      recaptcha_token: recaptchaToken,
    })
    return response.data
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>("/auth/forgot-password", { email })
    return response.data
  },

  resetPassword: async (token: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.post<{ message: string }>("/auth/reset-password", {
      token,
      new_password: newPassword,
    })
    return response.data
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>("/auth/refresh-token", {
      refresh_token: refreshToken,
    })
    return response.data
  },

  getUserOrganizations: async (userId: string): Promise<UserOrganizationAccess[]> => {
    const response = await api.get<UserOrganizationAccess[]>(`/auth/users/${userId}/organizations`)
    return response.data
  },

  switchOrganization: async (organizationId: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>(`/auth/switch-organization/${organizationId}`)
    return response.data
  },

  getUserInfo: async (): Promise<User> => {
    const response = await api.get<User>("/auth/users/me")
    return response.data
  },

  markUserAsOnboardingCompleted: async (userId: string): Promise<void> => {
    const response = await api.put(`/auth/users/${userId}`, {
      onboarding_completed: true,
    })
    return response.data
  },
}
